mutation UpdateTag($id: ID!, $input: UpdateTagInput!) {
  updateTag(id: $id, input: $input) {
    id
    title
    description
    type {
      id
      title
    }
    image {
      id
      url(format: HIGH)
    }
    verticalImage {
      id
      url(format: HIGH)
    }
    customFieldValues {
      name
      value
    }
    platformPage {
      id
      title
      path
    }
    createdAt
    updatedAt
  }
}
